export default __webpack_public_path__ + "static/playstore-nl-927e572c37188a0aa195be921c7265fc.png";